// Matterportユーティリティ
export type MPMode = 'mode.transitioning' | 'mode.inside';

export class MPUtils {
    mySelf: MPUtils;
    iconIDs: string[];
    recentTagId: string; //クリックされた最新のタグ
    //コンストラクタ　Matterport SDKクラスを設定する
    //mpSdkをパブリックプロパティに設定
    constructor(public mpSdk) {
        this.mySelf = this; //あらゆる場合にこのクラスを指定できるように、コンストラクタでthis=本クラスを変数に確保しておく
    }

    //SID配列を取得
    public GetSIDs() {
        let sids: string[] = [];
        this.mpSdk.Mattertag.getData()
            .then(function (mattertags) {
                //console.log(typeof (mattertags));
                //console.log(mattertags);
                if (mattertags.length > 0) {
                    mattertags.forEach(value => sids.push(value.sid));
                }
            })
            .catch(function (error) {
                console.log("Can't get MP tags");
                console.log(error);
            })
        return sids;
    }

    //アイコン画像の登録 旧MatterTag版
    public RegisterIcons(icons: { name: string, data: string }[], header = "") {
        let mpSdk = this.mpSdk;
        this.iconIDs = [];
        //console.log(name, data);
        icons.forEach((elem, index) => {
            let iconName = elem.name;
            let iconData = header + elem.data;
            this.iconIDs.push(iconName);
            console.log('RegisterIcons', index, iconName, iconData);
            mpSdk.Mattertag.registerIcon(iconName, iconData);
        })
        return this.iconIDs;
    }
    //アイコン画像の登録 Tag2.0対応
    public RegisterIconsNew(icons: { name: string, data: string }[], index=0, header = "") {
        let mpSdk = this.mpSdk;
        this.iconIDs = [];
        //console.log(name, data);
        icons.forEach((elem, i) => {
            let iconName = elem.name;
            let iconData = header + elem.data;
            this.iconIDs.push(iconName);

            if (i == index){
                console.log('registerTexture', index, iconName, iconData);
                mpSdk.Asset.registerTexture(iconName, iconData)
                .then(function(){
                    mpSdk.Mattertag.getData()
                    .then(function (mattertags) {
                        console.log('mattertags', mattertags.length);
                        if (mattertags.length > 0) {
                            mattertags.forEach(value => {
                                const tagsid = value.sid;
                                console.log("{ sid: \"" + tagsid + "\"\, label: \"" + value.label + "\" },")
                                //this.mpUtils.SetTagImageOfNew(value.sid, icons[index]);  //Mattertag 2.0
                                try {
                                    mpSdk.Tag.editIcon(tagsid, iconName);
                                    console.log('SetTagImageOf', tagsid, iconName);
                                } catch (error) {
                                    console.log("******** Can't edit tags");
                                    console.log(error);
                                    mpSdk.Tag.resetIcon(tagsid);
                                }
                            })
                        }
                    }).catch(function (error) {
                            console.log("******** Can't set tags");
                            console.log(error);
                    });
                })
                .catch(function (error) {
                    console.log("******** Can't Register tags");
                    console.log(error);
                })    
            }else{
                mpSdk.Asset.registerTexture(iconName, iconData);
            }
            
        })
        return this.iconIDs;
    }

    public GetTagTrans(callback) {
        //タグの位置（角度）のTransformを返す
        let transforms = [];
        this.mpSdk.Mattertag.getData()
            .then(function (tags) {
                for (let tag of tags) {
                    let transform = { sid: tag.sid, x: tag.anchorPosition.x, y: tag.anchorPosition.y, z: tag.anchorPosition.z, rx: 0, ry: 0 };
                    transforms.push(transform);
                }
                //console.log(transforms);
                callback(transforms);
            })
            .catch(function (error) {
                console.log(error);
            });
        //return transforms;
    }


    public InhibitTagHover(clickCallback = null, preventHoverOpen = true, preventClickOpen = false) {
        //タグアイコンのホバーを禁止する
        //console.log('InhibitTagHover');
        let mpSdk = this.mpSdk;
        mpSdk.on(mpSdk.Mattertag.Event.HOVER, function (sid, hovering) {
            //console.log(sid);
            if (preventHoverOpen) {
                if (hovering) {
                    console.log('hovering');
                    mpSdk.Mattertag.preventAction(sid, {
                        opening: true,  //いったんホーバーを無効にする
                    });
                }
            }
        });

        //タグクリック・イベント
        mpSdk.on(mpSdk.Mattertag.Event.CLICK, function (sid) {
            //console.log(sid);
            mpSdk.Mattertag.preventAction(sid, {
                opening: preventClickOpen,
            });
            if (clickCallback != null) {
                //console.log('clickCallback ', sid);
                clickCallback(sid);
            } else {
                console.log('clickCallback is null');
            }
        });
    }

    public SweepEventListener() {
        this.mpSdk.on(this.mpSdk.Sweep.Event.ENTER, function (fromSweep, toSweep) {
            //console.log('Sweep.Event.ENTER'+ fromSweep + ', ' +  toSweep);
        });
        this.mpSdk.on(this.mpSdk.Sweep.Event.EXIT, function (fromSweep, toSweep) {
            //console.log('Sweep.Event.EXIT'+ fromSweep + ', ' + toSweep);
        });
    }


    // 指定したひとつのタグアイコン画像変更　旧MatterTag版
    public SetTagImageOf(tagsid, iconName: string) {
        let mpSdk = this.mpSdk;
        try {
            //console.log('SetTagImageOf', tagsid, iconName);
            mpSdk.Mattertag.editIcon(tagsid, iconName);
        } catch (error) {
            //console.log(error);
            mpSdk.Mattertag.resetIcon(tagsid);
        }
    }
    // 指定したひとつのタグアイコン画像変更 MatterTag 2.0対応
    public SetTagImageOfNew(tagsid, iconName: string) {
        let mpSdk = this.mpSdk;
        try {
            console.log('SetTagImageOf', tagsid, iconName);
            mpSdk.Tag.editIcon(tagsid, iconName);
        } catch (error) {
            //console.log(error);
            mpSdk.Tag.resetIcon(tagsid);
        }
    }
    // 指定した複数のタグアイコン画像を変更
    public SetTagImagesOf(tagsids: string[], iconName: string) {
        let mpSdk = this.mpSdk;
        for (var tagsid of tagsids) {
            try {
                //console.log(tagsid, iconName);
                if (this.iconIDs.includes(iconName)) {
                    mpSdk.Mattertag.editIcon(tagsid, iconName);
                } else {
                    mpSdk.Mattertag.resetIcon(tagsid);
                }
            } catch (error) {
                //console.log('reset icon image');
                mpSdk.Mattertag.resetIcon(tagsid);
            }
        }
    }

    //指定したアイコンの有効化・無効化
    public EnableTagOf(tagsid: string, alpha = 1.0) {
        this.SetTagAlphaOf(tagsid, alpha, false);
    }
    public DisableTagOf(tagsid: string, alpha = 0.0) {
        this.SetTagAlphaOf(tagsid, alpha, true);
    }

    // 指定した複数のタグアイコンの透明度を設定
    public SetTagAlphaOf(tagsid: string, alpha: number = 1.0, prevent: boolean = false) {
        let mpSdk = this.mpSdk;
        try {
            mpSdk.Mattertag.editOpacity(tagsid, alpha);
            mpSdk.Mattertag.preventAction(tagsid, {
                opening: true,
                navigating: prevent
            });
        } catch (error) {
            console.log(error);
            mpSdk.Mattertag.resetIcon(tagsid);
        }
    }

    // 指定した場所に移動、かつ、指定した方向に回転
    public MoveTo(sweepId, rotation, transition: ('none' | 'fly' | 'fade'), transitionTime: number) {
        let trType;
        //console.log(transition);
        if (transition == 'fly') {
            trType = this.mpSdk.Sweep.Transition.FLY;
        } else if (transition == 'fade') {
            trType = this.mpSdk.Sweep.Transition.FADEOUT;
        } else {
            trType = this.mpSdk.Sweep.Transition.INSTANT;
        }
        this.mpSdk.Sweep.moveTo(sweepId, {
            rotation: rotation,
            transition: trType,
            transitionTime: transitionTime,
        })
            .then(function (sweepId) {
                // Move successful.
                //console.log('Sweeped to ' + sweepId);
            })
            .catch(function (error) {
                // Error with moveTo command
                console.log(error);
            });
    }

    //指定した方向に回転
    public RotateTo(rotation: { x: number, y: number }, speed: { speed: number }) {
        this.mpSdk.Camera.setRotation(
            rotation,
            speed,
        )
            .catch(function (error) {
                // Error with moveTo command
                console.log(error);
            });
    }

    //指定サイズへズーム
    public ZoomTo(factor: number) {
        this.mpSdk.Camera.zoomTo(factor)
            .then(function (newZoom) {
                //console.log('Camera zoomed to', newZoom);
            });
    }
    //指定した割合だけズーム
    public ZoomBy(increment: number) {
        this.mpSdk.Camera.zoomBy(increment)
            .then(function (newZoom) {
                //console.log('Camera zoomed to', newZoom);
            });
    }
    //ズームをリセット
    public ZoomReset() {
        this.mpSdk.Camera.reset()
            .then(function () {
                //console.log('Camera zoom has been reset');
            })
    }

    public PoseToStr(posedata, np = 2, nr = 2) {
        //Poseデータを文字列に変換　np:位置データの小数点以下桁数、nr:角度データの小数点以下桁数
        let sd = posedata.mode;
        let px = posedata.position.x;
        let py = posedata.position.y;
        let pz = posedata.position.z;
        let rx = posedata.rotation.x;
        let ry = posedata.rotation.y;
        let str = ' pos:' + px.toFixed(np) + ',' + py.toFixed(np) + ',' + pz.toFixed(np) + ' rot:' + rx.toFixed(nr) + ',' + ry.toFixed(nr) + ' sd:' + sd;
        return str;
    }

    public PoseMonitor(callback) {
        //カメラ位置の取得（サブスクリプション）
        console.log('Subscribe to pose');
        this.mpSdk.Camera.pose.subscribe(function (pose) {
            let debugout = false;
            //let md = pose.mode;
            if (debugout) {
                let sd = pose.sweep;
                let px = pose.position.x;
                let py = pose.position.y;
                let pz = pose.position.z;
                let rx = pose.rotation.x;
                let ry = pose.rotation.y;
                console.log(pose.mode, px, py, pz);
                console.log('{name:\'xxxxxx\', sweepId:\' ', sd, '\', rotation:{ x: ', rx.toFixed(3), ', y:', ry.toFixed(3), ' }},');
            }
            callback(pose);
        })
    }

    //位置トラッキング有効化
    public PositionTracker(checkpoints: ({ pid: string, position: { x: number, y: number, z: number } })[], resMax = 0.01) {
        //カメラ位置の取得（サブスクリプション）
        this.mpSdk.Camera.pose.subscribe(function (pose) {
            // UUIDと位置（X,Y)を判断
            //console.log(pose.position.x, pose.position.y, pose.position.z);
            let id = 9999;
            checkpoints.forEach((elem, index) => {
                let pid1 = String(pose.sweep);
                let pid2 = String(elem.pid);
                // '=='では等価にならない！sid2に余計な文字が入っている様子。このためindexOf()を使った。
                if (pid2.indexOf(pid1) > -1) {
                    //if(sid2 == sid1){
                    let res = Math.sqrt((pose.position.x - elem.position.x) ** 2
                        + (pose.position.y - elem.position.y) ** 2
                        + (pose.position.z - elem.position.z) ** 2);
                    //console.log("res", res);
                    if (res < resMax) {
                        id = index;
                        //console.log('reached to ', elem.pid);
                        //console.log('{name:\'entrance\', sweepId:\' ', pose.sweep, '\', rotation:{ x: ', pose.rotation.x.toFixed(3), ', y:', pose.rotation.y.toFixed(3), ' }},');
                    }
                }
            })
            return id;

        });
    }


}